<template>
	<v-card
        style="position:relative;"
        
	>
		<v-card-title
			class="text_primary"
            style="position:"
		>
			{{ page_title }}

			<v-spacer></v-spacer>
            <v-btn
                class="mr-2 white--text"
                color="#5087e6"
                @click="createSetting"
            >
                新增
            </v-btn>
		</v-card-title>


        <v-card-text>
            <v-row>
                <v-col
                    cols="12"
                    lg="5"
                    md="5"
                    sm="12"
                >
                    <v-card>
                        <v-card-title
                            class="text_primary c-subtitle"
                        >
                            基本設定
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    lg="7"
                    md="7"
                    sm="12"
                >
                    <v-card>
                        <v-card-title
                            class="text_primary c-subtitle"
                        >預覽
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>

	</v-card>
</template>
<script>
export default {
    name: 'WaterMarkerEdit',
    components: {
    },
    data: function() {
        return {	
            page_title: "浮水印設定",
            setting: {
                name: '',
                start_at: '',
                end_at: '',
                url: '',
                is_detail_show: false,
            },
            markers: [],
            marker: {
                postion: '',
                offset: {},
                style: {},
            }
        }
    },
    created: async function(){

        let breadcrumbs = [
            {
                "text": "目錄優化",
                disabled: true,
            },
            {
                "text": "浮水印",
                disabled: false,
                href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/category/water_marker/`
            },
        ]
        if (this.$route.params.id) {
            breadcrumbs.push({
                "text": "片美美",
            })
        }
        else {
            breadcrumbs.push({
                "text": "新增",
            })
        }
        this.$store.commit('update_breadcrumbs',breadcrumbs)
    },
    mounted: async function() {
        this.initData()
    },
    methods: {
        initData: async function(){
        },
        createSetting(){
            
        }
    },	
    computed: {
    }     
}
</script>
<style scoped>
.c-subtitle {
    font-size: 18px !important;
}
</style>